module.exports = __webpack_public_path__ + "img/V64.0ba7bcd8.jpg";